import {gql} from '@apollo/client';
import {useLazyQuery} from '@apollo/client/react';

// Droits nécessaires : ADMIN_COOPTATIONS ou OWN_PROFILE
const GET_COOPTATION_PAYMENT = gql`
  query CooptationPayment($uuid: ID!) {
    cooptationPayment(uuid: $uuid) {
      amount
      cooptant {
        firstname
        lastname
        uuid
      }
      coopted {
        firstname
        lastname
        uuid
      }
      currency
      linkedStatementOperationUuid
      month
      cooptationType  
      retributionPercentage
      cooptationPercentage
      uuid
      valueDate
      year
    }
  }
`;

export const useCooptationPayment = () => {
  const [getCooptationPayment, { loading, error, data, refetch }] = useLazyQuery(GET_COOPTATION_PAYMENT, {
    fetchPolicy: "network-only",
  });

  return {
    loading,
    error,
    data: data?.cooptationPayment,
    refetch,
    getCooptationPayment: (uuid) => getCooptationPayment({ variables: { uuid } }),
  };
};
